import { useEffect, useState } from "react";
import { generateUID } from "verdi-common/utils/HelperFunctions";
import { MasterIndex } from "verdi-web-client/Models";
import { IrrigationDeviceBase } from "verdi-web-client/Models/Devices/IrrigationDeviceBase";
import { isDeviceInManualMode } from "@/services/device-attributes/attributes/operating-mode/getters";

// Get the manual devices list for a zone
const getManualDevices = (zoneId: string) => {
    const zone = MasterIndex.zone.byID[zoneId];
    if (!zone) return [];
    return zone.devices.filter(
        (device): device is IrrigationDeviceBase =>
            device instanceof IrrigationDeviceBase && isDeviceInManualMode({ model: device }),
    );
};
/**
 * Hook to get the devices in manual mode for a zone
 */
export const useZoneManualDevices = (zoneId: string) => {
    const [manualDevices, setManualDevices] = useState<IrrigationDeviceBase[]>([]);

    // Initialize state and attach event listeners to all devices in the zone
    useEffect(() => {
        setManualDevices(getManualDevices(zoneId));

        const devices =
            MasterIndex.zone.byID[zoneId]?.devices.filter(
                (device): device is IrrigationDeviceBase => device instanceof IrrigationDeviceBase,
            ) ?? [];

        const listenerIds: Record<string, string> = {};
        devices.forEach((device) => {
            const deviceListenerId = generateUID();
            listenerIds[device.id] = deviceListenerId;
            device.onChange.addListener(() => {
                // When a device changes, update the manual devices list
                setManualDevices(getManualDevices(zoneId));
            }, deviceListenerId);
        });
        return () => {
            devices.forEach((device) => {
                if (listenerIds[device.id]) {
                    device.onChange.removeListener(listenerIds[device.id]);
                }
            });
        };
    }, [zoneId]);

    return manualDevices;
};
